/**
 *  Example: you have something with the type '(string | undefined)[]' and you want to remove the all
 * instances of undefined to make the type 'string[]'
 * https://stackoverflow.com/questions/47632622/typescript-and-filter-boolean
 */
export function nonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
